module.exports = __webpack_public_path__ + "static/media/Bronn 2.01324349.jpg";